import React, { useState } from 'react';
import { Box, Button, Typography, Paper, Stack } from '@mui/material';
import { DateField, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { COLORS } from '../../settings/themeSettings';
import dayjs from 'dayjs';

const SageExportPage = () => {
    const [startDate, setStartDate] = useState(dayjs().startOf('month'));
    const [endDate, setEndDate] = useState(dayjs().endOf('month'));

    const handleExport = () => {
        // Simulation of export generation
        const header = "Journal;Date;CompteG;CompteT;Libelle;Debit;Credit\n";
        const dummyData = `VE;${startDate.format('DDMMYY')};706000;;Vente prestation;1500.00;\n`;
        const blob = new Blob([header + dummyData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `export_sage_${startDate.format('YYYYMMDD')}_${endDate.format('YYYYMMDD')}.csv`;
        a.click();
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ p: 3 }}>
                <Typography variant="h4" sx={{ mb: 4, color: COLORS.secondary }}>
                    Export comptable SAGE
                </Typography>

                <Paper sx={{ p: 4, maxWidth: 600 }}>
                    <Stack spacing={4}>
                        <Typography variant="body1">
                            Sélectionnez la période pour générer le fichier d'écriture comptable.
                        </Typography>

                        <Stack direction="row" spacing={2}>
                            <DateField
                                label="Date début"
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                format="DD-MM-YYYY"
                                fullWidth
                            />
                            <DateField
                                label="Date fin"
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                format="DD-MM-YYYY"
                                fullWidth
                            />
                        </Stack>

                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={handleExport}
                        >
                            Générer le fichier d'export
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        </LocalizationProvider>
    );
};

export default SageExportPage;
